const STEPS = {
  STEP_BASE_INFO: 'STEP_BASE_INFO',
  STEP_ADDITIONAL_INFO: 'STEP_ADDITIONAL_INFO',
  STEP_WAIVER: 'STEP_WAIVER',
  STEP_CONFIRMATION: 'STEP_CONFIRMATION',
}

export const StepLabels = {
  [STEPS.STEP_BASE_INFO]: 'Participant Information',
  [STEPS.STEP_ADDITIONAL_INFO]: 'Additional Information',
  [STEPS.STEP_WAIVER]: 'Waiver',
  [STEPS.STEP_CONFIRMATION]: 'Confirmation',
}

export const getSteps = ({ waiverEnabled = false } = {}) =>
  [
    StepLabels.STEP_BASE_INFO,
    StepLabels.STEP_ADDITIONAL_INFO,
    waiverEnabled && StepLabels.STEP_WAIVER,
    StepLabels.STEP_CONFIRMATION,
  ]
    .filter(Boolean)
    .map(name => ({ name }))
